import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import OpportunityCard from "@/components/OpportunityCard";
import { Link } from "react-router-dom";

export default function Saved() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/saved").then(r => setItems(r.data.saved || [])); }, []);
  return (
    <div className="max-w-3xl mx-auto px-5 pt-6">
      <div className="eyebrow text-[#FD0F10]">SAVED PATHS</div>
      <h1 className="font-display text-3xl font-black mt-1">Your shortlist.</h1>
      {items.length === 0 ? (
        <div className="mt-8 card-panel p-6 text-center">
          <p className="text-gray-400">Nothing saved yet.</p>
          <Link to="/dashboard" className="mt-3 inline-block hero-accent px-4 py-2 rounded font-bold" data-testid="saved-empty">Browse paths</Link>
        </div>
      ) : (
        <div className="mt-6 grid gap-4">
          {items.map(o => <OpportunityCard key={o.id} opp={{ ...o, locked: false }} isSaved onToggleSave={(id,s)=>!s && setItems(items.filter(i=>i.id!==id))} />)}
        </div>
      )}
    </div>
  );
}
